import React from 'react';
import axios from 'axios';
import { put, select } from 'redux-saga/effects';
import {
  createRequestInstance,
  watchRequests,
} from 'redux-saga-requests';
import { createDriver } from 'redux-saga-requests-axios';
import { GET_USER_PROFILE } from '../constants';
import { logout } from '../actions/user';
import { AppToaster } from '../components/Toaster';

axios.defaults.withCredentials = true;

function* onResponseSaga(response, action) {
  if (action.type === GET_USER_PROFILE) {
    if (![1, 443].includes(response.data.content.organization_id)) {
      yield put(logout());
    }
  }
  return response;
}

function* onErrorSaga(error, action) {
  if (error.response && error.response.status === 401) {
    // With a refresh token, auth/session.js owns 401 recovery (refresh and
    // retry) and logs out only when AuthKit rejects the refresh; dropping the
    // session here could wipe a just-refreshed valid token.
    const token = yield select(state => state.currentUser.token);
    if (!token || !token.refresh_token) {
      yield put(logout());
    }
  }
  if (action && action.meta && action.meta.silent) {
    return { error };
  }
  if (error.response && error.response.data) {
    if (error.response.data.result) {
      AppToaster.show({
        icon: 'error',
        message: (
          <span>
            <strong>
              Error:&nbsp;
              {error.response.data.result.errorCode}
            </strong>
            <br />
            {error.response.data.result.errorMessage || ''}
          </span>
        ),
        intent: 'danger',
      });
    }
  }

  return { error };
}

function* rootSaga() {
  yield createRequestInstance({
    driver: createDriver(axios),
    onSuccess: onResponseSaga,
    onError: onErrorSaga,
  });
  yield watchRequests({
    getLastActionKey: action => (action.meta || {}).actionKey || action.type,
  });
}

export default rootSaga;
